import { Component, OnInit, Input } from '@angular/core';
import { Appointment } from '../appointment';

@Component({
  selector: 'mc-appointment-detail',
  templateUrl: './appointment-detail.component.html',
  styleUrls: ['./appointment-detail.component.scss']
})
export class AppointmentDetailComponent implements OnInit {

  @Input() appointment: Appointment;

  constructor() { }

  ngOnInit() {
  }

}
